import {Button, Stack} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import {format} from 'date-fns';
import ru from 'date-fns/locale/ru';
import {forwardRef, useImperativeHandle, useState} from 'react';
import {DateRange, Range, RangeKeyDict} from 'react-date-range';
import {DATETIME_ISO_FORMAT} from '../../../../../../shared/constants/date-formats';
import {STYLES} from './styles';

export interface PeriodPickerRef {
  open: () => void;
  close: () => void;
  reset: () => void;
}

interface Props {
  startDate?: string;
  endDate?: string;
  onClose?: () => void;
  onAccept?: (startDate: string, endDate: string) => void;
}

const DEFAULT_STATE: Range = {
  startDate: new Date(),
  endDate: new Date(),
  key: 'selection',
} as const;

export const PeriodPicker = forwardRef<PeriodPickerRef, Props>(({onAccept, onClose}, ref) => {
  const [isOpenPicker, setOpenPicker] = useState(false);
  const [state, setState] = useState<Range>(DEFAULT_STATE);

  const handleChange = (item: RangeKeyDict) => {
    setState(item.selection);
  };

  const handleOpen = () => {
    setOpenPicker(true);
  };

  const handleAccept = () => {
    const {startDate, endDate} = state;
    if (!startDate || !endDate) return;
    onAccept?.(format(startDate, DATETIME_ISO_FORMAT), format(endDate, DATETIME_ISO_FORMAT));
    setOpenPicker(false);
  };

  const handleClose = () => {
    setOpenPicker(false);
    onClose?.();
  };

  const handleResetPeriod = () => {
    setState(DEFAULT_STATE);
  };

  useImperativeHandle(ref, () => ({
    open: handleOpen,
    close: handleClose,
    reset: handleResetPeriod,
  }));

  return (
    <Dialog open={isOpenPicker} fullWidth maxWidth="sm" onClose={handleClose}>
      <DialogContent>
        <Stack sx={STYLES.container}>
          <DateRange
            onChange={handleChange}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={[state]}
            direction="horizontal"
            locale={ru}
            showDateDisplay={false}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Отмена</Button>
        <Button onClick={handleAccept}>Применить</Button>
      </DialogActions>
    </Dialog>
  );
});
